import React from "react";
import { MainContent } from "../../utilities/mainContent";
import TableData from "../../utilities/table";
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Chip,
  Stack,
  // Drawer,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import { MenuButtons } from "../../utilities/menuButton";
// import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { DialogBox } from "../../utilities/dialog";
import { Add } from "../users/add";
import EditIcon from "@mui/icons-material/Edit";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { DeleteContent } from "../../../hooks/utils";
import { usePerms } from "../../../hooks/usePerms";
import DepartmentServices from "../../../service/department";

const items = [
  {
    label: "Edit Depart Email",
    icon: <EditIcon fontSize="small" />,
  },
  {
    label: "Delete Email",
    icon: <DeleteIcon fontSize="small" />,
  },
];

const itemsAdmin = [
  {
    label: "Edit Depart Email",
    icon: <EditIcon fontSize="small" />,
  },
];

const csvCol = [
  {
    key: "email",
    label: "Email"
  },
  {
    key: "department",
    label: "Department",
   
  },
  {
    key: "status",
    label: "Status",
   
  },

  {
    key: "updatedAt",
    label: "Updated at ",
  },
  {
    key: "createdAt",
    label: "Created at",
  },
];

export const EmailComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [setMobileOpens, setMobileOpenss] = React.useState(false);
  const [departEmail, setDepartEmail] = React.useState(null);
  const [filtered, setFiltered] = React.useState(null);
  const [isDelete, setIsDelete] = React.useState(false);
  const entryRole = ["admin", "superAdmin"];
  const entryRole2 = ["superAdmin"];
  const { role: admin } = usePerms("", entryRole);
  const { role } = usePerms("", entryRole2);

  const roleCheck = role ? items : itemsAdmin;
  const { data, isLoading } = useQuery({
    queryKey: ["department_email_list"],
    queryFn: () => DepartmentServices.allDepartmentEmails(),
  });

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = () => {
    setMobileOpenss(!setMobileOpens);
  };

const columns = [
  {
    field: "email",
    headerName: "Email",
    width: 280,
  },
  {
    field: "departNames",
    headerName: "Department",
    width: 250,
    // Extract and format array of department objects into a comma-separated string
    valueGetter: (params) => {
      // Handles both direct array structure and API response shapes safely
      const departments = params?.value || params?.row?.departNames || [];
      if (!Array.isArray(departments)) return "";
      return departments.map((d) => d.name || d).join(", ");
    },
    // Optional custom rendering using MUI Chips for a cleaner UI
    renderCell: (params) => {
      const departments = params.value ? params.value.split(", ") : [];
      if (departments.length === 0) return <span>-</span>;
      return (
        <Stack direction="row" spacing={0.5} sx={{ overflowX: "auto", py: 1 }}>
          {departments.map((dept, index) => (
            <Chip key={index} label={dept} size="small" variant="outlined" />
          ))}
        </Stack>
      );
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    renderCell: (params) => (params.value ? "Active" : "Inactive"),
  },
  {
    field: "updatedAt",
    headerName: "Updated at",
    width: 150,
  },
  {
    field: "createdAt",
    headerName: "Created at",
    width: 150,
  },
  {
    field: "actions",
    headerName: "",
    width: 80,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <Grid container justifyContent="flex-end">
          <IconButton
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={(event) => handleClick(event, params.row)} // Pass params.row to target specific item
            disabled={!admin}
          >
            <MoreVertIcon />
          </IconButton>
          <MenuButtons
            anchorEl={anchorEl}
            open={open}
            handleClose={handleClose}
            items={roleCheck.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => handleMenuItem(item, params.row)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText>
                  <Typography variant="subtitle2">{item.label}</Typography>
                </ListItemText>
              </MenuItem>
            ))}
          />
        </Grid>
      );
    },
  },
];

  const handleMenuItem = (item, params) => {
    if (item.label === "Sites") {
      toggleDrawer();
      setAnchorEl(null);
    } else if (item.label === "Edit Depart Email") {
      // navigate('/inspection/edit');
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === "Delete Email") {
      setAnchorEl(null);
      setIsDelete(true);
      // setSelectedData((prev) => ({
      //   ...prev,
      //   isSelected: true,
      //   rowId: params.id,
      // }));
    } else {
      return null;
    }
  };
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: DepartmentServices.departmentEmail,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["department_email_list"] });
      setIsDelete(false);
    },
  });
  return (
    <>
      <MainContent
        csvData={data}
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        fileNameWithFilter={"Email list"}
        fileName={"Department Email list"}
        valueFrom="add_spot"
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || "";
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) =>
              item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1,
          );
          setFiltered(() => value);
        }}
        title="Department email"
        items={
          <TableData
            cols={columns}
            rows={filtered || data}
            maxWidthMob="84vw"
            height="400px"
            isLoading={isLoading}
            onRowClick={({ row }) => setDepartEmail(() => row)}
          />
        }
        isBtnName={true}
        btnName={"Add"}
        onBtnNameClick={() => {
          setDepartEmail(() => null);
          setIsDialog(() => true);
        }}
      />
      <DialogBox
        handleClose={() => setIsDialog(() => false)}
        open={isDialog}
        title={
          <Typography variant="subtitle1 span">Department Email</Typography>
        }
        content={
          <Add
            label_name="email"
            handleClose={() => setIsDialog(() => false)}
            departEmail={departEmail}
            mutationFn={
              departEmail
                ? DepartmentServices?.departmentEmail
                : DepartmentServices?.addDepartmentEmail
            }
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(() => false)}
        open={isDelete}
        maxWidth="500px"
        title={
          <Typography variant="subtitle1" component="span">
            Delete Email
          </Typography>
        }
        content={
          <DeleteContent
            title="Are you sure you want to delete this departEmail?"
            onCancel={() => setIsDelete(false)}
            onSubmit={() => {
              const id = departEmail.id;
              const method = "delete";
              mutate({ id, method });
            }}
          />
        }
      />
    </>
  );
};
